//@ts-check

/**
 * @type {import("./types").getFileExtensionType}
 */
export default function getFileExtension(path) {
  if (path.indexOf('.') === -1) return '';
  return path.split('.').pop();
}